import { render } from "./community_write2.vue?vue&type=template&id=b235f5e6"
import script from "./community_write2.vue?vue&type=script&lang=js"
export * from "./community_write2.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__